import axios from 'axios';

const useFingerControl = (setState: any) => {

    const fpHTTSrvOpEP = 'http://127.0.0.1:15170/fpoperation';

    const checkFPHTTServer = () => {
        axios.get(fpHTTSrvOpEP)
            .then((response) => {
                console.log(response);
            }, (error) => {
                setState((prev: any) => { return { ...prev, message: 'Driver not installed' } })
                console.log(error);
            });
    };

    const beginOperation = (opName: string, libName: string, samplenum: number) => {
        checkFPHTTServer();

        const data = {
            'operation': opName,
            'username': '',
            'usedlib': libName,
            'samplenum': samplenum,
            'isoconv': true
        };

        axios.post(fpHTTSrvOpEP, data)
            .then((response) => {
                parseOperationDsc(response.data,);
            }, (error) => {
                console.log(error);
            });
    };

    const getOperationState = (opId: string) => {
        axios.get(fpHTTSrvOpEP + '/' + opId)
            .then((response) => {
                parseOperationDsc(response.data);
            }, (error) => {
                console.log(error);
            });
    };

    const getOperationImg = (opId: string) => {
        axios.get(fpHTTSrvOpEP + '/' + opId + '/image', { responseType: 'arraybuffer' })
            .then((response) => {
                const uint8Array = new Uint8Array(response.data);
                setState((prev: any) => { return { ...prev, uint8Array: uint8Array, opId: opId } })
            }, (error) => {
                console.log(error);
            });
    };

    const linkOperationTemplate = (opId: string, opName: string,) => {

        axios.get(fpHTTSrvOpEP + '/' + opId + '/template', { responseType: 'arraybuffer' })
            .then((response) => {
                const uint8Array = new Uint8Array(response.data);
                const fingerTemplate = arrayBufferToBase64(uint8Array)
                setState((prev: any) => { return { ...prev, fingerTemplate: fingerTemplate, opId: opId } })
            }, (error) => {
                console.log(error);
            });

    };

    const arrayBufferToBase64 = (buffer: any) => {
        var binary = '';
        var bytes = buffer;
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    const parseOperationDsc = (operationDsc: any,) => {
        if (operationDsc.state === 'done') {

            if (operationDsc.status === 'success') {
                setState((prev: any) => { return { ...prev, message: operationDsc.message, opId: operationDsc.id } })
                linkOperationTemplate(operationDsc.id, operationDsc.operation);
            } else if (operationDsc.status === 'fail') {
                setState((prev: any) => { return { ...prev, message: operationDsc.errorstr, opId: operationDsc.id } })
                if (parseInt(operationDsc.errornum) !== -1) {
                    axios.delete(fpHTTSrvOpEP + '/' + operationDsc.id)
                        .then((response) => {
                            console.log(response)
                        }, (error) => {
                            console.log(error);
                        });
                }
            }
        }
        else if (operationDsc.state === 'init') {

            setTimeout(getOperationState, 1000, operationDsc.id);
            setTimeout(getOperationImg, 1000, operationDsc.id, parseInt(operationDsc.devwidth), parseInt(operationDsc.devheight));
        }
        else if (operationDsc.state === 'inprogress') {

            if (operationDsc.fingercmd === 'puton') {
                setState((prev: any) => { return { ...prev, message: 'Put finger on scanner', opId: operationDsc?.id } })
            }

            if (operationDsc.fingercmd === 'takeoff') {
                setState((prev: any) => { return { ...prev, message: 'Take off finger from scanner', opId: operationDsc?.id } })
            }

            setTimeout(getOperationState, 1000, operationDsc.id);
            setTimeout(getOperationImg, 1000, operationDsc.id, parseInt(operationDsc.devwidth), parseInt(operationDsc.devheight));
        }

        return true;
    };


    return beginOperation

};

export default useFingerControl